const getHelpMixpanel = (user)  => {
   return {
      type: 'HELP_MIXPANEL',
      payload: user,
      meta: {
        mixpanel: {
           event: 'getHelp',
           props: {
            sentFrom: "web",
            userName: user.nickName,
            userId: user.id,
           }
        }
      }
   }
}

export default getHelpMixpanel;



// WEBPACK FOOTER //
// ./src/actions/mixpanel/getHelpMixpanel.js